// extracted by mini-css-extract-plugin
export default {"Box":"y-axis-selector-module__Box--_mZlq","SelectorLabel":"y-axis-selector-module__SelectorLabel--VjYmJ","ActionMenu_Button":"y-axis-selector-module__ActionMenu_Button--RRQ5g"};